module.exports = __webpack_public_path__ + "static/media/icon-delete.c36af4a8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/icon-delete.svg
// module id = 1454
// module chunks = 0